export const aiKnowledgeManagementSolutionsContactFormId =
  'aiKnowledgeManagementSolutionsContactForm';
